// extracted by mini-css-extract-plugin
export default {"noPaddingWrapper":"rich-product-module--no-padding-wrapper--662f2"};